import React from "react";
import styled from "styled-components";
import { size } from "styled-theme";
import { CrumbContainer } from "./crumb.styles";
import { Crumb } from "./crumb";

const BreadCrumbContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 17px;

  ${CrumbContainer} {
    flex: 20;

    &:first-of-type, &:last-of-type {
      flex: 13;
    }

    @media only screen and (min-width: ${size("M")}) {
      flex: 1;

      &:first-of-type, &:last-of-type {
        flex: 1;
      }
    }
  }
`;

export const BreadCrumb = ({currentStep, steps, stepsMobile, statusThemeColor, showIndicatorStatus, daysUntilExpiry, declineIsActive}) => {

  return (
    <BreadCrumbContainer className="bread-crumb-container">
      {steps.map((step, crumbNumber) => (
        <Crumb
          key={`crumb-${crumbNumber}`}
          crumbNumber={crumbNumber}
          currentCrumb={currentStep}
          totalCrumbs={steps.length}
          step={step}
          stepMobile={stepsMobile[crumbNumber]}
          statusThemeColor={statusThemeColor}
          showIndicatorStatus={showIndicatorStatus}
          daysUntilExpiry={daysUntilExpiry}
          declineIsActive={declineIsActive}
        />
      ))}
    </BreadCrumbContainer>
  );
};